import { render, staticRenderFns } from "./CustomerDetailsCreditDatabase.vue?vue&type=template&id=06a86144"
import script from "./CustomerDetailsCreditDatabase.vue?vue&type=script&lang=js"
export * from "./CustomerDetailsCreditDatabase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports